import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var isStorageAvailable = function isStorageAvailable() {
  return typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";
};

/**
 * Single source of truth for the finance calculator session key.
 * Returns null when the post id is missing so callers never read/write
 * `installment-calculator-undefined`.
 */
export var getInstallmentCalculatorKey = function getInstallmentCalculatorKey(postId) {
  if (postId === null || postId === undefined || postId === "") return null;
  if (typeof postId === "number" && !Number.isFinite(postId)) return null;
  return "installment-calculator-".concat(postId);
};
export var readInstallmentCalculatorData = function readInstallmentCalculatorData(postId) {
  var key = getInstallmentCalculatorKey(postId);
  if (!key || !isStorageAvailable()) return null;
  try {
    var raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (_unused) {
    return null;
  }
};
export var writeInstallmentCalculatorData = function writeInstallmentCalculatorData(postId, data) {
  var key = getInstallmentCalculatorKey(postId);
  if (!key || !isStorageAvailable()) return false;
  try {
    sessionStorage.setItem(key, JSON.stringify(data));
    return true;
  } catch (_unused2) {
    // sessionStorage full or unavailable
    return false;
  }
};

/** Merges into the existing entry instead of replacing it. */
export var mergeInstallmentCalculatorData = function mergeInstallmentCalculatorData(postId, data) {
  var existing = readInstallmentCalculatorData(postId) || {};
  return writeInstallmentCalculatorData(postId, _objectSpread(_objectSpread({}, existing), data));
};
export var removeInstallmentCalculatorData = function removeInstallmentCalculatorData(postId) {
  var key = getInstallmentCalculatorKey(postId);
  if (!key || !isStorageAvailable()) return;
  try {
    sessionStorage.removeItem(key);
  } catch (_unused3) {
    // ignore
  }
};
export var CALCULATOR_DATA_UPDATED_EVENT = "calculatorDataUpdated";
export var dispatchInstallmentCalculatorUpdate = function dispatchInstallmentCalculatorUpdate(postId, data) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(CALCULATOR_DATA_UPDATED_EVENT, {
    detail: {
      postId: postId,
      data: data
    }
  }));
};